module.exports = __webpack_public_path__ + "static/img/t2@2x.4592c21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/picture/t2@2x.jpg
// module id = ftEh
// module chunks = 1